import { MdOutlineClear } from 'react-icons/md';
import { PiCalendarCheckBold, PiCalendarDotsBold } from 'react-icons/pi';
import { IconToggle } from '@ui';
import { Button } from '@ds';
import { WorkdaySyncData } from '@lp/features/Scheduler/types';
import { FilterOptionsDropdown, SchedulerResourcesFilter } from '@lp/features/Scheduler/components';
import { scheduleFiltersSelectors } from '@lp/core/store/scheduler';
import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { getUseSSchedulerFiltersStore } from '@lp/features/Scheduler/SchedulerSurgeons/factories';
import { SResourcesWithShifts } from '@/api/apis/resources/schedule';

type SSchedulerFiltersSectionProps = {
  readonly?: boolean;
  organGroup: SOrganGroup;
  shiftsData: SResourcesWithShifts;
  workdayData?: WorkdaySyncData;
  isReservationsView: boolean;
  setIsReservationsView: (value: boolean) => void;
};

export const SSchedulerFiltersSection = ({
  readonly,
  organGroup,
  shiftsData,
  workdayData,
  isReservationsView,
  setIsReservationsView,
}: SSchedulerFiltersSectionProps) => {
  const useSSchedulerFiltersStore = getUseSSchedulerFiltersStore(organGroup);
  const hasActiveFilters = useSSchedulerFiltersStore(scheduleFiltersSelectors.hasActiveFilters);
  const filters = useSSchedulerFiltersStore();

  return (
    <div className="flex items-center gap-4">
      {hasActiveFilters && (
        <Button disableRipple size="sm" variant="light" endContent={<MdOutlineClear />} onPress={filters.clearFilters}>
          Clear all
        </Button>
      )}
      <SchedulerResourcesFilter
        shiftsData={shiftsData}
        selectedKeys={filters.resources}
        onSelectedKeysChange={(ids) => filters.setFilterByKey('resources', ids)}
      />
      <FilterOptionsDropdown
        onlyStatusFilter={readonly}
        statusFilterEnabled={filters.statusFilters}
        onStatusFilterChange={(enable) => filters.setFilterByKey('statusFilters', enable)}
        workdayData={workdayData}
      />
      <IconToggle
        isSelected={isReservationsView}
        onValueChange={setIsReservationsView}
        enableIcon={<PiCalendarCheckBold />}
        disableIcon={<PiCalendarDotsBold />}
      />
    </div>
  );
};
